import { useMutation } from '@tanstack/react-query';
import * as service from '../services';
import { useEditBaseTableStore } from '../EditBaseTable.store';
import { useEffect } from 'react';
import { useCreateComercialTableStore } from '../../CreateComercialTable/CreateComercialTable.store';

export const useBaseTableBigNumbers = () => {
  // createComercialTableBody.idTabelaBase é preenchido por causa EditBaseTable -> useTabelaBase
  const { createComercialTableBody } = useCreateComercialTableStore();

  const { setEditBaseTableState } = useEditBaseTableStore();

  const getComercialBigNumbers = async data => {
    const hasID = createComercialTableBody?.idTabelaBase !== undefined && createComercialTableBody?.idTabelaBase !== null;
    if (!hasID) return;

    const body = {
      id: createComercialTableBody?.idTabelaBase,
      descricao: data.descricao || [],
      familia: data.familia || [],
      tier: data.tier || [],
    };
    const resp = await service.getBaseTableBigNumbers(body);
    return resp;
  };

  const successAction = data => {
    setEditBaseTableState('editBaseTableBigNumbersData', data.data);
  };

  const mutate = useMutation({
    mutationFn: async (payload: any) => await getComercialBigNumbers(payload),
    onSuccess: data => successAction(data),
  });

  useEffect(() => {
    mutate.mutateAsync({});
  }, [createComercialTableBody?.idTabelaBase]);

  return {
    handleGetBaseTableBigNumbers: mutate.mutateAsync,
  };
};
